<script lang="ts" setup>
import { Menu } from '@/ui/common/layout/menu'
import { Header } from '@/ui/common/layout/header'
import { useAuthStore } from '@/store/auth-store'
import { storeToRefs } from 'pinia'
import { useHeaderVisibility } from '@/composables/use-header-visibility'

const authStore = useAuthStore()
const { isAuthenticated } = storeToRefs(authStore)
const {
  isShowHeader,
  isAuthLayout,
  isShowHeaderTop
} = useHeaderVisibility()

</script>

<template>
  <div class="Layout">
    <div class="Layout__main">
      <Menu v-if="isAuthenticated && !isAuthLayout" />
      <div
        class="Layout__middleSection"
        :class="{
          'drawer-menu': isAuthenticated,
          'hidden-header': !isShowHeader,
          auth: isAuthLayout,
        }"
      >
        <Header v-if="isShowHeaderTop" />
        <RouterView />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/assets/styles/media' as media;
.Layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.Layout__main {
  display: flex;
  flex: 1;
}

.Layout__middleSection {
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-left: 304px;
  position: relative;
  overflow-y: auto;
  background-color: var(--gray_white);

  &.drawer-menu {
    margin-top: 56px;
  }

  &.hidden-header {
    margin-top: 0;
  }

  &.auth {
    margin-left: 0;
  }

  @include media.max(media.$tablet) {
    margin-left: 0;
  }
}

.Layout__overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.Layout__overlay_active {
  display: block;
}
</style>
